var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 30,
    height: 30,
    transform: "translate(1183.5 994.5)",
    fill: "none",
    stroke: "#b7b5b6",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_59",
    "data-name": "Mask Group 59",
    transform: "translate(-1183.5 -994.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M14.55,22.54h2.112V14.092H14.55Zm.95-11.053a1.146,1.146,0,0,0,.828-.324,1.073,1.073,0,0,0,.334-.8,1.179,1.179,0,0,0-.334-.853,1.167,1.167,0,0,0-1.65-.005l-.005.005a1.173,1.173,0,0,0-.334.853,1.073,1.073,0,0,0,.334.8,1.14,1.14,0,0,0,.826.324Zm.01,18.093a13.626,13.626,0,0,1-5.474-1.109A14.05,14.05,0,0,1,5.556,5.538a14.455,14.455,0,0,1,4.482-3.01A14.067,14.067,0,0,1,28.47,20.964a14.387,14.387,0,0,1-3.01,4.473,14.213,14.213,0,0,1-4.47,3.027,13.625,13.625,0,0,1-5.481,1.116Zm.008-2.112a11.958,11.958,0,1,0-8.483-3.5,11.5,11.5,0,0,0,8.485,3.5Z",
    transform: "translate(1183 994)",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.51275db744f7f3ac143823ddca765115.svg";
export { ForwardRef as ReactComponent };